<form [formGroup]="rentForm">
  <div class="m-2 p-2 text-white">
    <h3>Editar</h3>
  </div>
  <div class="flex flex-col m-2 p-2">
    <div class="flex flex-row gap-1">
      <div class="w-1/2">
        <oden-input
          type="date"
          formControlName="fecha_inicio_renta"
          label="{{'PURCHASES.START_DATE' | translate}}"
        ></oden-input>
      </div>
      <div class="w-1/2">
        <oden-input
          type="date"
          formControlName="fecha_fin_renta"
          label="{{'PURCHASES.END_DATE' | translate}}"
        ></oden-input>
      </div>
    </div>
    <div>
      <oden-input
        type="text"
        formControlName="garantia"
        label="{{'PURCHASES.WARRANTY' | translate}}"
      ></oden-input>
    </div>
    <div class="flex flex-row mt-4 gap-1 justify-end">
      <oden-button text="{{'GLOBAL.BUTTONS.CANCEL' | translate}}" color="secondary" (click)="onCancel()"></oden-button>
      <oden-button text="{{'GLOBAL.BUTTONS.KEEP' | translate}}" color="primary" (click)="onSubmit()"></oden-button>
    </div>
  </div>
</form>
